// extracted by mini-css-extract-plugin
export default {"blog-page-container":"BlogPage_blog-page-container__vKyVh"};